import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBundle } from "../../../_actions/bundle.actions";
import { Loading } from "../../Other/Loading";
import { CourseItem } from "./CourseItem";
const BundleList = ({}) => {
  const dispatch = useDispatch();

  const bundleCousers = useSelector((state) => {
    const { bundleCourses, loading } = state.bundleCourses;
    return {
      bundleCourses: bundleCourses,
      loading: loading,
    };
  });

  const parseAndShortDescription = (description) => {
    const parsed = description?.replace(/<[^>]*>/g, "");
    if (parsed?.length > 180) {
      const shortenend = parsed?.slice(0, 280);
      return shortenend;
    }
    return parsed;
  };

  useEffect(() => {
    dispatch(fetchBundle());
  }, []);
  return (
    <>
      <section className="container-wrapper">
        {bundleCousers.loading ? (
          <Loading />
        ) : (
          <>
            {bundleCousers?.bundleCourses?.length > 0 ? (
              bundleCousers.bundleCourses?.map((course, index) => (
                <div key={index + course.CourseName}>
                  <CourseItem
                    item={course}
                    allbundle={true}
                    parseAndShortDescription={parseAndShortDescription}
                    //  getApprovedCourses={getAprroveCourse}
                  />
                </div>
              ))
            ) : (
              <div className="no-bundle-found">
                <span className="record-not-found">No Record found</span>
              </div>
            )}
          </>
        )}
      </section>
    </>
  );
};

export default BundleList;
